import { HttpClient } from "@angular/common/http";
import { IResult } from "app/common/interfaces";
import { AbstractService } from "app/services/abstract.service";
import { environment as env } from "../../../../../../environments/environment.prod";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import PhoneAttributes from "@albatrosdeveloper/ave-models-package/lib/schemas/common/embedded/phone/phone.entity";
import { IUpdateSalesOfficePhone } from "../interfaces/update-sales-office-phone.interface";
import { ICreateSalesOfficePhone } from "../interfaces/create-sales-office-phone.interface";
const apiUrl = env.API_CONFIGURATION_URL;
const moduleName = "sales_office_phone";

@Injectable({
  providedIn: "root",
})
export class SalesOfficePhoneService extends AbstractService<
  PhoneAttributes,
  ICreateSalesOfficePhone,
  IUpdateSalesOfficePhone
> {
  constructor(http: HttpClient) {
    super(apiUrl, moduleName, http);
  }

  /**
   * Pagination
   * @param options Pagination options
   * @returns Paginated data
   */
  findBySalesOfficeId(
    salesOfficeId: string
  ): Observable<IResult<PhoneAttributes>> {
    const API_URL: string = `${apiUrl}api/${moduleName}/${salesOfficeId}`;
    return this.http.get<IResult<PhoneAttributes>>(API_URL);
  }
}
